<template>
    <cadastro-simples-list
        endpoint="tipo-transporte"
        rota-base="/admin/tipo-transporte"
        titulo="MEIOS DE TRANSPORTE"
        titulo-singular="Meio de Transporte"
        :colunas-extras='[
            { campo: "cod_censo", label: "Cód. Censo", tipo: "string" }
        ]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
